import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/analytics';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/database';
import 'firebase/storage';

// firebase init goes here
const configOptions = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
};


firebase.initializeApp(configOptions);
firebase.analytics();

// firebase utils
const db = firebase.firestore();
const storage = firebase.storage();
const auth = firebase.auth();
const functions = firebase.functions();

if(process.env.NODE_ENV === "development") {
  functions.useEmulator("localhost", 5001);
  // auth.useEmulator("localhost", 5003)
  // db.useEmulator("localhost", 5004)
}

// firebase collections
const usersCollection = db.collection('users');
const eventsCollection = db.collection('events');
const siteCollection = db.collection('site');

// firebase storage references
const eventImageRef = storage.ref().child('images/events');
const avatarsRef = storage.ref().child('avatars');

// Functions
const connectUserTelegram = functions.httpsCallable('connectUserTelegram');
const disconnectUserTelegram = functions.httpsCallable('disconnectUserTelegram');
const setUserProfile = functions.httpsCallable('setUserProfile');
const rsvpEvent = functions.httpsCallable('rsvpEvent');
const getUpcomingEvents = functions.httpsCallable('getUpcomingEvents');
const swapInfo = functions.httpsCallable('swapInfo');

const actionCodeSettings = {
  // URL you want to redirect back to. The domain (www.example.com) for this
  // URL must be whitelisted in the Firebase Console.
  url: `${process.env.VUE_APP_SITE_ADDRESS}/login`,
  // This must be true.
  handleCodeInApp: true,
};

export {
  db,
  auth,
  connectUserTelegram,
  disconnectUserTelegram,
  storage,
  functions,
  usersCollection,
  eventsCollection,
  siteCollection,
  avatarsRef,
  eventImageRef,
  setUserProfile,
  rsvpEvent,
  getUpcomingEvents,
  actionCodeSettings,
  swapInfo
};
